import { atom } from "recoil";

export const sideState = atom({
  key: "isOpen",
  default: false,
});
